<template>
  <path
    d="M12 12.0002C13.1 12.0002 14 11.1002 14 10.0002C14 8.90018 13.1 8.00018 12 8.00018C10.9 8.00018 10 8.90018 10 10.0002C10 11.1002 10.9 12.0002 12 12.0002ZM12 2.00018C16.2 2.00018 20 5.22018 20 10.2002C20 13.3802 17.55 17.1202 12.66 21.4302C12.28 21.7602 11.71 21.7602 11.33 21.4302C6.45 17.1202 4 13.3802 4 10.2002C4 5.22018 7.8 2.00018 12 2.00018Z"
  />
</template>
